
const getUsedAccounts = usedAccounts => (usedAccounts > 0 ? usedAccounts : 1);

export default getUsedAccounts;
